import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Header.css";
import ScrollspyNav from "react-scrollspy-nav";
const Header = (props) => {
  return (
    <nav className="navbar navbar-sticky-top navbar-expand-lg" id="mynav">
      <a class="navbar-brand" href="#">
        <b style={{fontSize:'40px',marginLeft:'70px'}}>RAKIB</b>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span>
          <i class="fa fa-bars" aria-hidden="true"></i>
        </span>
       
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav" >
          <li class="nav-item active">
            <a class="nav-link" href="#about">
             <b>ABOUT</b> <span class="sr-only">(current)</span>
            </a>
          </li>
          <li class="nav-item">
            <a className="nav-link" href="#skills">
              <b>SKILLS</b>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#education">
              <b>EDUCATION</b>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#projects">
              <b>PROJECTS</b>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">
              <b>PORTFOLIO</b>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">
              <b>CONTRACT</b>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;
